import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from 'ziggy-vue';
import route from 'ziggy';
import { i18nVue } from 'laravel-vue-i18n';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faEdit,
	faExclamationCircle,
	faCheckCircle,
	faUserShield,
	faTrashCan,
	faCircle,
	faPeopleGroup,
	faChartColumn,
	faCheckSquare,
	faBan,
	faFilePdf,
	faPlus,
	faEye,
	faUser,
	faEnvelope,
	faPhone,
	faHome,
	faEarth,
	faEuroSign,
	faHatWizard,
	faBolt,
	faComputer,
	faReply,
	faFileZipper,
	faRotate,
	faChevronDown,
	faClock,
	faMoneyBillTrendUp,
	faArrowTrendDown,
	faArrowTrendUp,
	faCaretDown,
	faCaretUp,
	faBox,
	faFileContract,
	faPaperclip,
	faFile,
	faFileExcel,
	faFileWord,
	faFilePowerpoint,
	faLink,
	faMoneyBill,
	faCrown,
	faQuestionCircle,
	faList,
	faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import {
	faGoogle,
	faJira,
	faLinkedin,
	faSlack,
} from '@fortawesome/free-brands-svg-icons';

/* Tailwind Datepicker */
import VueTailwindDatepicker from 'vue-tailwind-datepicker';

import Vue3ColorPicker from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';

library.add(
	faEdit,
	faExclamationCircle,
	faCheckCircle,
	faUserShield,
	faTrashCan,
	faCircle,
	faPeopleGroup,
	faSlack,
	faGoogle,
	faJira,
	faChartColumn,
	faCheckCircle,
	faCheckSquare,
	faBan,
	faFilePdf,
	faPlus,
	faEye,
	faUser,
	faEnvelope,
	faPhone,
	faHome,
	faEarth,
	faLinkedin,
	faEuroSign,
	faHatWizard,
	faBolt,
	faCalendar,
	faComputer,
	faReply,
	faFileZipper,
	faRotate,
	faChevronDown,
	faClock,
	faMoneyBillTrendUp,
	faArrowTrendUp,
	faArrowTrendDown,
	faCaretDown,
	faCaretUp,
	faBox,
	faFileContract,
	faPaperclip,
	faFile,
	faFileExcel,
	faFileWord,
	faFilePowerpoint,
	faLink,
	faMoneyBill,
	faCrown,
	faQuestionCircle,
	faList,
	faInfoCircle,
);

import { settings } from '@uni/plugins/settings';
import { appHeader } from '@uni/plugins/app-header';
import filters from './filters';
import { initTheme } from './composables/useTheme';

const appName =
	window.document.getElementsByTagName('title')[0]?.innerText || 'Uni';

createInertiaApp({
	title: (title) =>
		title !== appName ? (title ? `${appName} | ${title}` : appName) : title,
	resolve: async (name) => {
		const page = () =>
			resolvePageComponent(
				`./pages/${name}.page.vue`,
				import.meta.glob('./pages/**/*.page.vue'),
			);

		const pageModule = () => {
			return resolvePageComponent(
				`./modules/${name}.page.vue`,
				import.meta.glob('./modules/**/*.page.vue'),
			);
		};

		const pagesResults = await Promise.allSettled([pageModule(), page()]);

		const maybePage = pagesResults.find((page) => !!page.value);

		if (!maybePage) {
			throw new Error('404: Page not Found');
		}

		return maybePage.value;
	},
	setup({ el, App, props, plugin }) {
		// the first paint was decided by the root view; this keeps the choice in step (docs/UI_THEME.md)
		initTheme(props.initialPage.props.theme);

		const application = createApp({ render: () => h(App, props) })
			.use(plugin)
			.use(settings)
			.use(appHeader)
			.use(ZiggyVue)
			.use(VueTailwindDatepicker)
			.use(Vue3ColorPicker)
			.use(i18nVue, {
				resolve: (lang) => {
					const langs = import.meta.glob('../../lang/*.json', { eager: true });
					return langs[`../../lang/${lang}.json`].default;
				},
			})
			.component('FontAwesomeIcon', FontAwesomeIcon)
			.mixin({
				methods: {
					route: route,
				},
			});

		const log = function (...data) {
			if (import.meta.env.VITE_APP_DEBUG === 'true') {
				console.log(...data);
			}
		};
		application.provide('log', log);

		application.config.globalProperties.$filters = filters;

		application.mount(el);
	},
	progress: {
		color: '#009FE3',
	},
});
